import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ReactMapboxGl, { GeoJSONLayer, Marker } from "react-mapbox-gl";
import { accessToken } from "../../accessToken";
import GeolocateControl from "../components/GeolocateControl";
import NavigationControl from "../components/NavigationControl";

const styles = theme => ({
  marker: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.dark,
    borderRadius: "20px",
    padding: "5px",
    border: "3px solid " + theme.palette.primary.dark,
    fontSize: "2em",
    pointerEvents: "none"
  },
  contentMarker: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.black,
    borderRadius: "20px",
    padding: "5px",
    border: "3px solid " + theme.palette.common.black,
    fontSize: "2em",
    pointerEvents: "none"
  }
  // toggleSurroundingNodes: {
  //   position: "absolute",
  //   top: 5,
  //   left: 5,
  //   zIndex: 10
  // }
});

const Map = ReactMapboxGl({
  accessToken
});

const lineLayout = {
  "line-join": "round",
  "line-cap": "round"
};
const linePaint = {
  "line-color": "#303F9F",
  "line-width": 5
};

const fitBoundsOptions = {
  // linear: true,
  padding: {
    top: 40,
    right: 40,
    bottom: 40,
    left: 40
  },
  maxZoom: 60
};

function Markers(props) {
  const { pois, classes } = props;
  return pois.map(poi => {
    const name = poi.description.split(" ")[2];
    if (poi.content) {
      return (
        <Marker
          key={poi.pid}
          coordinates={{ lng: poi.lon, lat: poi.lat }}
          anchor="bottom"
        >
          <span className={classes.contentMarker}>{name}</span>
        </Marker>
      );
    } else {
      return (
        <Marker
          key={poi.pid}
          coordinates={{ lng: poi.lon, lat: poi.lat }}
          anchor="bottom"
        >
          <span className={classes.marker}>{name}</span>
        </Marker>
      );
    }
  });
}

const symbolLayout = {
  "text-field": "{name}",
  "text-font": [
    "Roboto Regular",
    "Open Sans Semibold",
    "Arial Unicode MS Bold"
  ],
  "text-offset": [0, 0.12],
  "text-anchor": "center",
  "text-size": 25,
  "icon-image": "https://static.getjar.com/icon-50x50/44/876433_thm.png",
  "icon-allow-overlap": true,
  "text-allow-overlap": true
};
const symbolPaint = {
  "text-color": "#303F9F"
};

const circleLayout = {
  visibility: "visible"
};
const circlePaint = {
  "circle-radius": 20,
  "circle-color": "white",
  "circle-stroke-width": 3,
  "circle-stroke-color": "#303F9F"
};

class BikeNodeMap extends Component {
  constructor(props) {
    super(props);
    this.geolocateControl = React.createRef();
  }
  render() {
    const { geojson, fitBounds, classes, type } = this.props;

    let containerStyle = {
      height: "calc(100vh - 58px - 58px - 76px - 58px)",
      width: "100vw"
    };
    if (type === "ambassador") {
      containerStyle.height = "calc(100vh - 58px - 76px - 58px)";
    }
    return (
      <React.Fragment>
        {/* <div className={classes.toggleSurroundingNodes}>test</div> */}
        <Map
          style="mapbox://styles/mapbox/outdoors-v9" // eslint-disable-line react/style-prop-object
          containerStyle={containerStyle}
          fitBounds={fitBounds}
          fitBoundsOptions={fitBoundsOptions}
          onStyleLoad={() => {
            this.geolocateControl.current.trigger();
          }}
        >
          {geojson.pois ? (
            <Markers
              classes={classes}
              pois={geojson.pois}
              surroundingNodes={geojson.surroundingNodes}
            />
          ) : null}
          <GeoJSONLayer
            data={geojson}
            lineLayout={lineLayout}
            linePaint={linePaint}
          />
          <GeoJSONLayer
            data={geojson.surroundingNodes}
            circleLayout={circleLayout}
            circlePaint={circlePaint}
          />
          <GeoJSONLayer
            data={geojson.surroundingNodes}
            symbolLayout={symbolLayout}
            symbolPaint={symbolPaint}
          />

          <GeolocateControl ref={this.geolocateControl} />
          <NavigationControl />
        </Map>
      </React.Fragment>
    );
  }
}

BikeNodeMap.propTypes = {
  classes: PropTypes.object.isRequired,
  fitBounds: PropTypes.array.isRequired,
  geojson: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
};

export default withStyles(styles)(BikeNodeMap);



// WEBPACK FOOTER //
// ./src/NewRoute/atoms/BikeNodeMap.js